module.exports = "<div class=\"disallowedFiPanel\" ng-if=\"fi.declineReason || fi.gotDeclined\" content>\n    <span ng-if=\"fi.isPreferred\" class=\"preferredLabel\">{{ content('memberReview.preferred') }}</span>\n    <span class=\"message\">{{ content(fi.message) }}</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-ui-components/src/expired-fi-panel/template.html
// module id = ../node_modules/xo-ui-components/src/expired-fi-panel/template.html
// module chunks = 0